'use strict';

var MediaQueryDispatch$1 = require('./MediaQueryDispatch.js');

var MediaQueryDispatch = MediaQueryDispatch$1;
var src = new MediaQueryDispatch();

module.exports = src;
